<template>
  <div class="head_wrap_degin">
    <div class="head_other">
      <el-button @click="clearModle" size="small">更换模板</el-button>
      <el-button @click="saveSubmit(0)" size="small">暂存</el-button>
      <el-button @click="saveSubmit(1)" size="small">保存并发布</el-button>
    </div>
  </div>
</template>
<script>
import api from "../../api";
export default {
  name: "applettop",
  props: ["property"],
  data() {
    return {
      fullscreenLoading: false,
      company: {
        pic: null,
        name: null
      }
    };
  },
  created(){
	  console.log(this.property,"option25===*******====*******")
    this.InitFn()
  },
  methods: {
    InitFn() {
      this.axios
          .post(api.company_index, {})
          .then(response => {
            if (response.data.code == 0) {
              this.company.pic = response.data.info.pic
              this.company.name = response.data.info.name
            } else {
            }
          })
          .catch(response => {
          });
    },
    saveSubmit(option){
		console.log(option,this.property,"option42===*******====***")
      // 发布状态(0仅保存、1发布)
      // if(this.property.length === 0){
      //   this.$message({
      //     message: '请编辑相应的内容！',
      //     type: 'warning'
      //   });
      //   return
      // }
      let data_ = []
      for(let i in this.property){
      //   let obj_ = {}
      //   obj_.type = this.property[i].type;
      //   obj_.content = this.property[i].content;
	  
		if(this.property[i].type===1){
			let obj_ = {}
			obj_.type = this.property[i].type
			obj_.sort = this.property[i].sort
			obj_.content = []
			let content = {}
			let contents = {}
			for(let j in this.property[i].content.pic){
				console.log(this.property[i].content.pic[j],"j222==-=-=-=-=-=-==-=-=--")
				if(this.property[i].content.pic[j].subtype == '2'){
					content.pic = this.property[i].content.pic[j].response.path
					content.jump_type = 101
					content.jump_option_id = this.property[i].content.pic[j].id
					obj_.content.push(content)
				}else if(this.property[i].content.pic[j].subtype != '2'){
					contents.pic = this.property[i].content.pic[j].response.path
					contents.jump_type = this.property[i].content.pic[j].subtype
					contents.jump_option_id = 0
					obj_.content.push(contents)
				}
			}
			data_.push(obj_);
		}
		
		if(this.property[i].type===2){
			let obj_ = {}
			let templates_name = this.property[i].content.name
			let new_label_status = this.property[i].content.updates
			let init_visit_num = this.property[i].content.visits
			let init_sell_num = this.property[i].content.sales
			let search_goods_name = this.property[i].content.search_goods_name
			let auth_icon_status = this.property[i].content.enterprises
			let introduce = this.property[i].content.textareas
			obj_.type = this.property[i].type
			obj_.sort = this.property[i].sort
			// let content = []
			// content.push({templates_id:templates_id, new_label_status:new_label_status, init_visit_num:init_visit_num, init_sell_num:init_sell_num, search_goods_name:search_goods_name, auth_icon_status:auth_icon_status, introduce:introduce})
			obj_.content = {}
			obj_.content.templates_name = templates_name
			obj_.content.new_label_status = new_label_status
			obj_.content.init_visit_num = init_visit_num
			obj_.content.init_sell_num = init_sell_num
			obj_.content.search_goods_name = search_goods_name
			obj_.content.auth_icon_status = auth_icon_status
			obj_.content.introduce = introduce
			data_.push(obj_);
		}
	  
		if(this.property[i].type===3){
			let obj_ = {}
			let templates_name = this.property[i].content.name
			obj_.type = this.property[i].type
			obj_.sort = this.property[i].sort
			// obj_.content = []
			// let content = []
			// content.push({templates_id:templates_id})
			obj_.content = {}
			obj_.content.templates_name = templates_name
			data_.push(obj_);
		}
		
		if(this.property[i].type===4){
			let obj_ = {}
			obj_.type = this.property[i].type
			obj_.sort = this.property[i].sort
			obj_.content = []
			data_.push(obj_);
		}
      }
	  console.log(data_,"data_.push(obj_);95=*=**=**=**=**=*=*==*=**=*=")
	  // let objs = ''
	  // for(let i in data_){
		 //  objs = JSON.stringify(data_[i])
	  // }
	  // console.log(objs,"objs128=-=-=-****=-==-=-")
	  // let datas = JSON.stringify(data_)
	  // console.log(datas,"JSON.stringify(data_)125=-=-=-=-=-=-=*****")
	  // let datas_ =JSON.parse(datas)
	  // console.log(datas_,"JSON.stringify(data_)133=-=-=-=-=-=-=*****")
      // option
      const loading = this.$loading({
        lock: true,
        text: '努力保存中…',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)',
        color:"#fff"
      });

      this.axios
        .post(api.decorate_set_shopmall, {shopmall:JSON.stringify(data_),release:option})
        .then(response => {
          if (response.data.code == 0) {
            loading.close();
            this.$notify({
              title: '操作成功',
              message: '您已保存成功',
              type: 'success'
            });
          } else {
          }
        })
        .catch(response => {
        });
    },
    clearModle(){
      this.$confirm('更换模版将删除当前模板中已编辑的内容，且删除的内容不可恢复，请谨慎操作。', '', {
        confirmButtonText: '继续',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning'
      }).then(() => {
        this.axios
            .post(api.shopconf_set_website, {website:JSON.stringify([]),release:0})
            .then(response => {
              if (response.data.code == 0) {
                this.$emit('changeInit')
                this.$notify({
                  title: '操作成功',
                  message: '您已更换模板成功',
                  type: 'success'
                });
              } else {
              }
            })
            .catch(response => {
            });
      }).catch(() => {
      });
    }
  }
};
</script>
